export default "__VITE_ASSET__BCcALnkp__"